export const GAME_WIN_COMPONENT_TOKEN = Symbol('GAME_WIN_COMPONENT_TOKEN');

export interface AddWinParams {
  animDuration?: number;
  animFrom?: number;
}

export interface GameWinComponent {
  addWin(win: number, params?: AddWinParams): void;
  updateWin(win: number): void;
  resetWin(): void;
  completeWinAnimation?(): void;
}
